/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type MachineType,
    MachineTypeFromJSON,
    MachineTypeToJSON,
} from '../models/MachineType';

export interface CreateMachineTypeRequest {
    /**
     * 
     */
    machineType: MachineType;
}

export interface DeleteMachineTypeRequest {
    /**
     * 
     */
    id: string;
}

export interface GetMachineTypeRequest {
    /**
     * 
     */
    id: string;
}

export interface UpdateMachineTypeRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    machineType: MachineType;
}

/**
 * 
 */
export class MachineTypeControllerApi extends runtime.BaseAPI {

    /**
     * Creates request options for createMachineType without sending the request
     */
    async createMachineTypeRequestOpts(requestParameters: CreateMachineTypeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['machineType'] == null) {
            throw new runtime.RequiredError(
                'machineType',
                'Required parameter "machineType" was null or undefined when calling createMachineType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/machine-types`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MachineTypeToJSON(requestParameters['machineType']),
        };
    }

    /**
     */
    async createMachineTypeRaw(requestParameters: CreateMachineTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MachineType>> {
        const requestOptions = await this.createMachineTypeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MachineTypeFromJSON(jsonValue));
    }

    /**
     */
    async createMachineType(requestParameters: CreateMachineTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MachineType> {
        const response = await this.createMachineTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteMachineType without sending the request
     */
    async deleteMachineTypeRequestOpts(requestParameters: DeleteMachineTypeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteMachineType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/machine-types/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deleteMachineTypeRaw(requestParameters: DeleteMachineTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteMachineTypeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteMachineType(requestParameters: DeleteMachineTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteMachineTypeRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getAllMachineTypes without sending the request
     */
    async getAllMachineTypesRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/machine-types`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getAllMachineTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MachineType>>> {
        const requestOptions = await this.getAllMachineTypesRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MachineTypeFromJSON));
    }

    /**
     */
    async getAllMachineTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MachineType>> {
        const response = await this.getAllMachineTypesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getMachineType without sending the request
     */
    async getMachineTypeRequestOpts(requestParameters: GetMachineTypeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getMachineType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/machine-types/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getMachineTypeRaw(requestParameters: GetMachineTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MachineType>> {
        const requestOptions = await this.getMachineTypeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MachineTypeFromJSON(jsonValue));
    }

    /**
     */
    async getMachineType(requestParameters: GetMachineTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MachineType> {
        const response = await this.getMachineTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateMachineType without sending the request
     */
    async updateMachineTypeRequestOpts(requestParameters: UpdateMachineTypeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateMachineType().'
            );
        }

        if (requestParameters['machineType'] == null) {
            throw new runtime.RequiredError(
                'machineType',
                'Required parameter "machineType" was null or undefined when calling updateMachineType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/machine-types/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MachineTypeToJSON(requestParameters['machineType']),
        };
    }

    /**
     */
    async updateMachineTypeRaw(requestParameters: UpdateMachineTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MachineType>> {
        const requestOptions = await this.updateMachineTypeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MachineTypeFromJSON(jsonValue));
    }

    /**
     */
    async updateMachineType(requestParameters: UpdateMachineTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MachineType> {
        const response = await this.updateMachineTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
